import { useState } from "react";
import EnterpriseDatamodel from "../assets/EnterpriseDatamodel.jpg";
import IndustryDatamodel from "../assets/IndustryDataModel.png";
import GenAI from "../assets/GenAI.jpg";
import Migration from "../assets/Migration.jpg";

export default function IntelligentSolutions() {
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);

  const cards = [
    {
      title: "Industry Data Model",
      description:
        "Built for sector-specific needs, our models deliver clean, structured analytics that accelerate business outcomes",
      image: IndustryDatamodel,
    },
    {
      title: "Generative AI",
      description:
        "Innovate at scale using AI that uncovers deep insights, automates complex analysis, and drives smarter decisions",
      image: GenAI,
    },
    {
      title: "Enterprise Data Analytics",
      description:
        "Unlock intelligent insights and drive transformation through integrated analytics across enterprise platforms",
      image: EnterpriseDatamodel,
    },
    {
      title: "Migrations & Lakehouse",
      description:
        "Efficiently modernize your data landscape with seamless migrations and robust, scalable lakehouse architectures",
      image: Migration,
    },
  ];

  const toggleExpand = (index: number) => {
    setExpandedIndex((prev) => (prev === index ? null : index));
  };

  return (
    <section className="px-4 sm:px-6 md:px-12 lg:px-20 py-16 sm:py-20 bg-white flex flex-col items-center gap-16">
      {/* Header */}
      <div className="max-w-4xl text-center flex flex-col gap-4 sm:gap-6 px-2">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold text-zinc-700 tracking-wide font-['IBM_Plex_Sans']">
          Pioneering Intelligent Analytics Solutions
        </h2>
        <p className="text-base sm:text-lg md:text-xl text-gray-700 leading-relaxed tracking-tight font-['Nunito Sans']">
          Accelerating growth and delivering impact with unified, <br />
          AI-powered data analytics and enterprise-ready solutions
        </p>
      </div>

      {/* Cards */}
      <div className="flex flex-wrap justify-center gap-4 sm:gap-6 md:gap-8 w-full">
        {cards.map((card, i) => {
          const isExpanded = expandedIndex === i;

          return (
            <div
              key={i}
              className={`
                relative overflow-hidden rounded-lg text-center shadow-sm hover:shadow-md transition-all duration-500 ease-in-out cursor-pointer
                ${isExpanded ? "w-[90vw] sm:w-[456px] h-[320px]" : "w-[40vw] sm:w-[180px] h-[320px]"}
              `}
              onClick={() => toggleExpand(i)}
            >
              {/* Background Image */}
              <img
                src={card.image}
                alt={card.title}
                className="absolute inset-0 w-full h-full object-cover"
              />

              {/* Dark overlay */}
              <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/60 to-black/90" />

              {/* Content */}
              <div className="relative z-10 flex flex-col justify-between items-center h-full px-4 py-6">
                {/* Title */}
                <h3 className="text-white font-['Nunito Sans'] text-base sm:text-lg md:text-xl lg:text-2xl font-semibold leading-snug">
                  {card.title}
                </h3>

                {/* Description */}
                <div
                className={`
                    absolute bottom-4 px-4 text-center text-white 
                    text-sm sm:text-base md:text-base lg:text-lg font-normal font-['Nunito Sans']
                    max-w-[90%] md:max-w-[440px] 
                    transition-all duration-700 ease-in-out
                    ${isExpanded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}
                `}
                >
                {card.description}
                </div>
                {/* Expand Button */}
                {!isExpanded && (
                  <div className="mt-4 p-2 w-7 h-7 flex items-center justify-center rounded-lg  outline outline-[2.50px] outline-offset-[-1.25px] outline-white text-white transition">
                    ➜
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
